import { platforms } from 'enums/app';

export const getAppId = state => state.appId;
export const getAuthError = state => state._authError;
export const getServerError = state => state._serverError;
export const getProactiveTriggered = state => state.proactiveTriggered;
export const isClientReady = state => state.clientReady;
export const isAppInitialized = state => state.initialized;
export const getChatClientConnectionStatus = state => state.chatClientConnectionStatus;
export const getDeviceId = state => state.app.deviceId;
export const getPlatform = state => state.app.platform;
export const getDeviceManufacturer = state => state.app.deviceManufacturer;
export const getDeviceModel = state => state.app.deviceModel;
export const getEstimatedWait = state => state.app.estimatedWait;
export const getOrgDomain = state => state.app.orgDomain;
export const getOrgId = state => state.app.orgId;
export const getOs = state => state.app.os;
export const getOsVersion = state => state.app.osVersion;
export const getSdkVersion = state => state.app.sdkVersion;
export const isMobileSdk = state =>
  state.app.platform === platforms.IOS ||
  state.app.platform === platforms.ANDROID ||
  state.app.platform === platforms.REACT_NATIVE;

export default {
  getAppId,
  getAuthError,
  getServerError,
  getProactiveTriggered,
  isClientReady,
  isAppInitialized,
  getChatClientConnectionStatus,
  getDeviceId,
  getPlatform,
  isMobileSdk,
  getDeviceManufacturer,
  getDeviceModel,
  getEstimatedWait,
  getOs,
  getOsVersion,
  getOrgDomain,
  getOrgId,
  getSdkVersion,
};
